import createHistory from "history/createBrowserHistory";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import "moment/locale/es";
import {Provider} from "react-redux";
import {ConnectedRouter, routerMiddleware, routerReducer} from "react-router-redux";
import {applyMiddleware, combineReducers, createStore} from "redux";
import {logger} from "redux-logger";
import * as ReduxThunk from "redux-thunk";
import "./assets/index.css";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import App from "./co/sura/App";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import registerServiceWorker from "./registerServiceWorker";
import {ThemeProvider} from "./co/sura/inicio/componentes/ThemeProvider";
import {consultarMenuEpic, consultarOficinasEpic, inicioReducer} from "./co/sura/inicio/modulos/inicioReducers";
import {combineEpics, createEpicMiddleware} from "redux-observable";
import {
    anularDocumentosEpic,
    aprobarDocumentosEpic,
    aprobarDocumentosComercialEpic,
    consultarDocumentosEpic,
    consultarDocumentosComercialEpic,
    consultarMotivosRechazoEpic,
    consultarDocumentoP8Epic,
    documentosReducer,
    rechazarDocumentosEpic,
    reportarDocumentosComercialEpic,
    consultarAfiliacionEpic,
    recibirDocumentosEpic,
    actualizarTipoDocumentalEpic,
    validarAsignacionEpic
} from "./co/sura/dominio/documentos/modulos/documentosReducers";
import {
    consultarTareasEpic, reintentarTareaEpic,
    tareasReducer
} from "./co/sura/dominio/bandeja/modulos/bandejaReducers";
import {
    consultarReporteEpic,
    consultarHistoricoEpic,
    obtenerXLSEpic,
    obtenerHistoricoXLSEpic,
    reportesReducer
} from "./co/sura/dominio/reportes/modulos/reportesReducers";
import { 
    consultarGlosasEpic, 
    gestionarGlosasEpic, 
    obtenerXLSDatosGlosasEpic, 
    glosasReducer,
    masivoGestionGlosasEpic
} from "./co/sura/dominio/sat/inconsistencias/modulos/bandejaGlosasReducers";
import { 
    maestrosReducer, 
    consultarMaestroUenEpic, 
    consultarMaestroTransaccionesSatEpic,
    consultarCatalogoGlosasSatEpic,
    consultarServiciosReciboSatEpic
} from "./co/sura/dominio/general/modulos/maestrosReducers";
import { 
    consultarDatosTrabajadorEpic, 
    trabajadoresReducer
} from "./co/sura/dominio/reportes/modulos/trabajadores/trabajadoresReducers";
import { 
    consultarEstructuraEmpresaEpic, 
    estructuraEmpresasReducer 
} from "./co/sura/dominio/sat/estructura_empresas/modulos/estructuraEmpresasReduces";
import { 
    enviarSATAfiliadoEpic,
    enviarSATMasivoAfiliadosEpic,
    descargarPlantillaMasivoEpic,
    envioEmpresasReducer
} from "./co/sura/dominio/sat/procesar_empresas/modulos/procesarEmpresasReducers";
import {
    consultarParametrosEpic,
    parametrosReducer,
    gestionarParametroEpic
} from "./co/sura/dominio/sat/config_parametros/modulos/adminParametroReducers";
import {
    consultarGlosasSATEpic,
    glosasSATReducer,
    gestionarGlosaSATEpic
} from "./co/sura/dominio/sat/config_glosas/modulos/adminGlosaReducers";
import {
    consultarServiciosEpic,
    gestionarServicioEpic,
    servciosReducer
} from "./co/sura/dominio/sat/config_servicios/modulos/adminServicioReducers";
import { 
    consultarPeriodosMoraEpic,
    descargarXLSPeriodosMoraEpic,
    periodosMoraReducer
} from "./co/sura/dominio/sat/periodos_mora/modulos/periodosMoraReducers";
import {
    descargarReporteXLSEpic
} from "./co/sura/dominio/sat/descarga_reporte/modulos/descargaReporteReducers";
import {
    descargarPlantillaAgrupadorasEpic,
    enviarAgrupadorasEpic,
    envioAgrupadorasReducer
} from "./co/sura/dominio/parametros/cargar_parametros/modulos/reducers";
import {
    consultarParametrosAgrupadorasEpic,
    parametrosAgrupadorasReducer,
    obtenerAgrupadorasXLSEpic
} from "./co/sura/dominio/parametros/consultar_parametros/modulos/parametrosReducers";
import {
    historicoRespuestaReducer,
    consultarHistoricoRespuestaEpic,
    descargarXLSHistoricoEpic
} from "./co/sura/dominio/sat/reporte_historico_rta/modulos/historicoRespuestaReducers";
import {     
    enviarSATRetiroEpic,
    enviarSATMasivoRetiroEpic,
    descargarPlantillaMasivoRetiroEpic,
    envioRetirosReducer
} from "./co/sura/dominio/sat/procesar_retiro/modulos/procesarRetiroReducers";
import {
    enviarSATMoraEpic,
    enviarSATMasivoMoraEpic,
    descargarPlantillaMasivoMoraEpic,
    envioMoraReducer
} from "./co/sura/dominio/sat/procesar_mora/modulos/procesaMoraReducers";
import {
    consultarEmpresaSATEpic,
    descargarXLSEmpresasEpic,
    empresasTrasladadasReducer
} from "./co/sura/dominio/sat/empresas_trasladadas/modulos/empresasTrasladadasReducers";
import {
    consultarReporteGeneralEpic,
    consultaReporteDetalleEpic,
    descargarXlsReporteGlosasEpic,
    reporteGlosasRespuestaReducer
} from "./co/sura/dominio/sat/reporte_glosas/modulos/ReporteGlosasReducers";
import {
    empresasTrasladoReducer,
    gestionarEmpresasTrasladoEpic,
    consultarEmpresasTrasladoEpic,
    descargarXLSEmpresasTrasladoEpic
} from "./co/sura/dominio/sat/gestion_empresas_trasladables/modulos/gestionEmpresaTrasladoReducers";
import {
    consultaTablaHistoricosReducer,
    consultarHistoricosMensajeEpic,
    consultarHistoricosRespuestaEpic,
    descargarXLSTablaHistoricoMsjEpic
} from "./co/sura/dominio/sat/consulta_tabla_historicos/modulos/consultaHistoricosReducers";
import {
    envioMasivoGlosasReducer,
    enviarGlosasConCodigoEpic,
    enviarMasivoGlosasEpic,
    descargarPlantillaMasivoGlosasEpic,
    generarArchivoFtpEpic
} from "./co/sura/dominio/sat/procesar_masivo_glosas/modulos/procesarMasivoGlosasReducers";
import {
    generarConsultaNovedadesRecibidasFtpEpic,
    descargarPlantillaMasivoEstadoEpic,
    consultaNovedadesRecibidasReducer
} from "./co/sura/dominio/sat/recibo_novedades_masivo/modulos/consultaNovedadesRecibidasReducers";
import {
    consultarNovedadesResumenEpic,
    consultarNovedadesResumenXLSEpic,
    reciboNovedadesResumenReducer
} from "./co/sura/dominio/sat/recibo_novedades_resumen/modulos/reciboNovedadesResumenReducers";
import {
    consultarNovedadesDetalleEpic,
    consultarNovedadesDetalleXLSEpic,
    enviarCambioEstadoEpic,
    reciboNovedadesDetalleReducer
} from "./co/sura/dominio/sat/recibo_novedades_detalle/modulos/reciboNovedadesDetalleReducers";
import {
    consultarEnviosMoraEpic,
    descargarXlsEnviosMoraEpic,
    consultaEnviosMoraReducer
} from "./co/sura/dominio/sat/consulta_envio_mora/modulos/consultaEnvioMoraReducers";

const history = createHistory();
const historyMiddleware = routerMiddleware(history);

const appEpics = combineEpics(
    consultarMenuEpic,
    consultarDocumentosEpic,
    consultarDocumentosComercialEpic,
    consultarDocumentoP8Epic,
    aprobarDocumentosEpic,
    aprobarDocumentosComercialEpic,
    anularDocumentosEpic,
    rechazarDocumentosEpic,
    reportarDocumentosComercialEpic,
    consultarMotivosRechazoEpic,
    consultarAfiliacionEpic,
    consultarOficinasEpic,
    recibirDocumentosEpic,
    consultarTareasEpic,
    reintentarTareaEpic,
    consultarReporteEpic,
    consultarHistoricoEpic,
    obtenerXLSEpic,
    obtenerHistoricoXLSEpic,
    actualizarTipoDocumentalEpic,
    validarAsignacionEpic,
    consultarGlosasEpic,
    gestionarGlosasEpic,
    obtenerXLSDatosGlosasEpic,
    masivoGestionGlosasEpic,
    consultarMaestroUenEpic,
    consultarMaestroTransaccionesSatEpic,
    consultarCatalogoGlosasSatEpic,
    consultarDatosTrabajadorEpic,
    consultarEstructuraEmpresaEpic,
    enviarSATAfiliadoEpic,
    enviarSATMasivoAfiliadosEpic,
    descargarPlantillaMasivoEpic,
    consultarParametrosEpic,
    gestionarParametroEpic,
    consultarGlosasSATEpic,
    gestionarGlosaSATEpic,
    consultarServiciosEpic,
    gestionarServicioEpic,
    consultarPeriodosMoraEpic,
    descargarXLSPeriodosMoraEpic,
    descargarReporteXLSEpic,
    enviarAgrupadorasEpic,
    descargarPlantillaAgrupadorasEpic,
    consultarParametrosAgrupadorasEpic,
    obtenerAgrupadorasXLSEpic,
    consultarHistoricoRespuestaEpic,
    descargarXLSHistoricoEpic,
    enviarSATRetiroEpic,
    enviarSATMasivoRetiroEpic,
    descargarPlantillaMasivoRetiroEpic,
    enviarSATMoraEpic,
    enviarSATMasivoMoraEpic,
    descargarPlantillaMasivoMoraEpic,
    consultarEmpresaSATEpic,
    descargarXLSEmpresasEpic,
    consultarReporteGeneralEpic,
    descargarXlsReporteGlosasEpic,
    consultaReporteDetalleEpic,
    gestionarEmpresasTrasladoEpic,
    consultarEmpresasTrasladoEpic,
    descargarXLSEmpresasTrasladoEpic,
    consultarHistoricosMensajeEpic,
    consultarHistoricosRespuestaEpic,
    descargarXLSTablaHistoricoMsjEpic,
    enviarGlosasConCodigoEpic,
    enviarMasivoGlosasEpic,
    descargarPlantillaMasivoGlosasEpic,
    generarArchivoFtpEpic,
    descargarPlantillaMasivoEstadoEpic,
    consultarServiciosReciboSatEpic,
    generarConsultaNovedadesRecibidasFtpEpic,
    consultarNovedadesResumenEpic,
    consultarNovedadesResumenXLSEpic,
    consultarNovedadesDetalleEpic,
    consultarNovedadesDetalleXLSEpic,
    enviarCambioEstadoEpic,
    consultarEnviosMoraEpic,
    descargarXlsEnviosMoraEpic
);

const epicMiddleware = createEpicMiddleware();

const store = createStore(
    combineReducers({
        router: routerReducer,
        inicio: inicioReducer,
        maestros: maestrosReducer,
        documentos: documentosReducer,
        bandeja: tareasReducer,
        reportes: reportesReducer,
        inconsistencias: glosasReducer,
        trabajadores: trabajadoresReducer,
        estructura_empresas: estructuraEmpresasReducer,
        estructura_afiliacion: envioEmpresasReducer,
        administrador_parametros: parametrosReducer,
        administrador_glosas: glosasSATReducer,
        administrador_servicios: servciosReducer,
        periodos_mora :periodosMoraReducer,
        estructura_agrupadoras: envioAgrupadorasReducer,
        report: parametrosAgrupadorasReducer,
        reporte_historico_rta: historicoRespuestaReducer,
        estructura_retiro: envioRetirosReducer,
        estructura_mora: envioMoraReducer,
        empresas_trasladadas: empresasTrasladadasReducer,
        reporte_glosas: reporteGlosasRespuestaReducer,
        gestion_empresas_traslado: empresasTrasladoReducer,
        consulta_tabla_historicos: consultaTablaHistoricosReducer,
        envio_masivo_glosas: envioMasivoGlosasReducer,
        recibo_novedades_masivo: consultaNovedadesRecibidasReducer,
        recibo_resumen_novedades: reciboNovedadesResumenReducer,
        recibo_detalle_novedades: reciboNovedadesDetalleReducer,
        consulta_envio_mora: consultaEnviosMoraReducer
    }),
    applyMiddleware(
        historyMiddleware,
        ReduxThunk.default,
        logger,
        epicMiddleware
    )
);

epicMiddleware.run(appEpics);
moment.locale("es");

const root = document.createElement("div");
document.body.appendChild(root);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <MuiThemeProvider muiTheme={ThemeProvider}>
                <App/>
            </MuiThemeProvider>
        </ConnectedRouter>
    </Provider>,
    root,
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx